import { useFormikContext } from "formik";
import React from "react";
import Input from "../../../../../components/form/Input";
import { Template } from "../../../../../models";
import {
  getMediaLinkPlaceholder,
  getMediaLinkTooltip,
  identifyUrlSource,
} from "../../../../../utils";

export default function MediaLinkInput() {
  const { values, errors, setFieldValue } =
    useFormikContext<Partial<Template>>();
  return (
    <div className="relative">
      <Input
        label="Media link"
        name="mediaUrl"
        value={values?.mediaUrl ?? ""}
        errorMessage={errors?.mediaUrl as string}
        errorPosition="bottom-left"
        placeholder={getMediaLinkPlaceholder(values.sourceId!)}
        tooltip={getMediaLinkTooltip(values.sourceId!)}
        onChange={({ target: { value } }) => {
          setFieldValue("mediaUrl", value.trim());
        }}
        onBlur={({ target: { value } }) => {
          const url = value.trim();
          if (url) {
            const sourceId = identifyUrlSource(url);
            setFieldValue("sourceId", sourceId);
          }
        }}
      />
    </div>
  );
}
